import { debounce, throttle } from 'es-toolkit';
import { useEffect, useLayoutEffect } from 'react';

import { SELECTOR } from '@/constants';

export const useGlobalEventListener = () => {
  useEffect(() => {
    const mainWrapper = document.getElementById(SELECTOR.MAIN);

    if (!mainWrapper) return;

    const handleScroll = debounce(({ target }: Event) => {
      if (target instanceof Element) {
        history.replaceState(
          {
            ...history.state,
            scrollY: target.scrollTop,
          },
          '',
        );
      }
    }, 100);

    mainWrapper.addEventListener('scroll', handleScroll);

    return () => {
      mainWrapper.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useLayoutEffect(() => {
    const updateHeight = () => {
      const height = window.visualViewport?.height || window.innerHeight;

      document.documentElement.style.setProperty(
        '--viewport-height',
        `${height}px`,
      );
    };

    // 초기값은 즉시 설정
    updateHeight();

    // scroll/resize는 throttle 적용 (100ms)
    const throttledUpdateHeight = throttle(updateHeight, 100);

    window.addEventListener('resize', throttledUpdateHeight);
    window.addEventListener('scroll', throttledUpdateHeight);
    window.visualViewport?.addEventListener('resize', throttledUpdateHeight);

    return () => {
      window.removeEventListener('resize', throttledUpdateHeight);
      window.removeEventListener('scroll', throttledUpdateHeight);
      window.visualViewport?.removeEventListener('resize', throttledUpdateHeight);
      throttledUpdateHeight.cancel();
    };
  }, []);

  useEffect(() => {
    const lockHtmlScroll = () => {
      window.scrollTo({
        top: 0,
        behavior: 'instant',
      });
    };

    window.addEventListener('scroll', lockHtmlScroll);

    return () => {
      window.removeEventListener('scroll', lockHtmlScroll);
    };
  }, []);
};
